export default __webpack_public_path__ + "static/media/hospital-icon.07c0870d.svg";